import {Component, OnInit} from "@angular/core";
import {Animations,
    BackendOberflaecheService,
    ErrorComponent
} from "@vhv/tarifrechner-common";
import { StartComponent } from '../start/start.component';

@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: '\error.component.html'
})
export class BaugeraeteErrorComponent extends ErrorComponent implements OnInit{

    ngOnInit(): void {
        window.removeEventListener('beforeunload', StartComponent.createMessageBeforeUnload);
    }

    constructor(
        private __inputBackendOberflaecheService: BackendOberflaecheService,
    ) {
        super(
            __inputBackendOberflaecheService,
        );
    }

}
